import { Copy } from "lucide-react";
import { toast } from "sonner";

/** Click-to-copy code chip used for every RN-/CO- code across the app. */
export const CopyCode = ({ code, testId, style }) => {
  if (!code) return <span className="muted">—</span>;
  const copy = () => { navigator.clipboard?.writeText(code); toast.success(`تم نسخ الرمز ${code}`); };
  return (
    <button type="button" className="copy-code" onClick={copy} title="نسخ الرمز" data-testid={testId || `copy-code-${code}`} style={style}>
      <code>{code}</code><Copy size={13} />
    </button>
  );
};
